/**
 * Get Sync Status API Contract
 *
 * GET /v1/schools/:schoolId/sync/status
 * Retrieve sync status for all sync types for a school.
 */

import { z } from 'zod'
import { DataSyncStatusSchema } from '../../schemas/entities/sync'

/**
 * Request Schema
 */
export const GetSyncStatusRequestSchema = z.object({
  schoolId: z.string().describe('School public ID')
})

export type GetSyncStatusRequest = z.infer<typeof GetSyncStatusRequestSchema>

/**
 * Response Schema
 */
export const GetSyncStatusResponseSchema = z.object({
  message: z.string(),
  data: z.array(DataSyncStatusSchema)
})

export type GetSyncStatusResponse = z.infer<typeof GetSyncStatusResponseSchema>
